export default __webpack_public_path__ + "static/media/invarch_icon.db990774.jpg";